// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__29W3O","box":"WorkspacesBox_box__1HNJg","node":"WorkspacesBox_node__1cX7V"};